import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Check from '@mui/icons-material/Check';

interface FeatureItemProps {
  text: string;
}

export default function FeatureItem({ text }: FeatureItemProps) {
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" spacing={1.5} height={56}>
      <Check
        sx={{
          color: theme.palette.semantic.icon.success,
          fontWeight: 700,
          fontSize: 29,
        }}
      />

      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          color: (theme) => theme.palette.text.primary,
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
}
